<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-100">
			<form-card
				title="Modification d'une activité"
				icon="edit"
				v-model="name"
				:goBack="goBack"
				:save="updateActivity"
				:error="error">
			</form-card>
		</div>
		<div class="md-layout-item md-size-50">
			<md-card>
				<md-card-header>
					<h4 class="title text-danger">Information importante</h4>
				</md-card-header>
				<md-card-content>
					La modification d'une activité impactera automatiquement
					tous les sites qui sont en lien avec cette activité.
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
import FormCard from "@/pages/Configuration/components/FormCard";

export default {
	name: "ActivityEdit",
	components: { FormCard },
	data() {
		return {
			name: null,
			error: null,
		}
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		async updateActivity() {
			if(this.name) {
				let activity = {
					id: this.$route.params.id,
					name: this.name.toUpperCase()
				}
				try {
					this.error = null
					await this.$store.dispatch('activities/updateActivites', activity)
					await this.$store.dispatch("alerts/success", "Activité modifié");
					this.$router.go(-1);
				} catch (e) {
					this.error = e.response.data.errors
				}
			} else {
				this.error = [{
					detail: 'Le nom d\'une activité ne peut pas être vide',
					source: { pointer: '/data/attributes/name' }
				}]
			}
		}
	},
	async mounted() {
		let { data } = await this.$store.dispatch('activities/getActivites')
		let activity = data.filter(s => s.id.toString() === this.$route.params.id.toString())
		if(activity) {
			this.name = activity[0].name
		}
	}
}
</script>

<style scoped>

</style>
